import AddButton, { AddButtonTemplate } from './AddButton';

export default AddButton;
export { AddButtonTemplate };
